module.exports = __webpack_public_path__ + "img/mago_meet.423736bb.png";